import { Component } from 'react';
import Dialog from 'material-ui/Dialog';
import CircularProgress from 'material-ui/CircularProgress';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import theme from '../../muiTheme';
import { DataGrid } from '@material-ui/data-grid';

const styles = {
    errorDialogContent: {
        width: "500px"
    },
    errorDialogTitle: {
        color: theme.palette.accent1Color
    }
};

export class ResourcesDialog extends Component {

    render() {
        if ((!this.props.open)) {
            return null;
        }

        const columns = [
            { field: 'HomeUnit', headerName: 'Home Unit', width: 220 },
            { field: 'ProviderAgency', headerName: 'Provider Agency', width: 180 },
            { field: 'ProviderUnit', headerName: 'Provider Unit', width: 140 },
            { field: 'Category', headerName: 'Category', width: 140 },
            { field: 'Code', headerName: 'Code', width: 100 },
            { field: 'Kind', headerName: 'Kind', width: 170 },
            { field: 'Type', headerName: 'Type', width: 170 }
        ];

        const rows = this.props.resourcesData.map(resource => {
            return {
                HomeUnit: resource.HomeUnit,
                ProviderAgency: resource.ProviderAgency,
                ProviderUnit: resource.ProviderUnit,
                Category: resource.Category,
                Code: resource.Code,
                Kind: resource.Kind,
                Type: resource.Type,
                id: resource.RowID
            }
        });


        const dialogContent = (this.props.isQuerying) ? (
            <div>Querying... <CircularProgress size={24} thickness={2} color={theme.palette.primary1Color} /></div>
        ) :
            (
                <div style={{ minHeight: 900, minWidth: 900 }}>
                    <DataGrid getRowId={(row) => row.RowID} isRowSelectable={false} rows={rows} columns={columns} pageSize={15} disableRowSelectionOnClick
                        autoPageSize />

                </div>
            );

        return (this.props.open) ? (

            <Dialog
            titleStyle={styles.errorDialogTitle}
            title="Incident Resources"
            open={this.props.open}
            modal={true}
            fullScreen
            autoScrollBodyContent={true}
            contentStyle={{ width: '50%', height: '60%', maxWidth: 'none', overflowy: 'auto' }}>
                   <DialogContent>
                   {dialogContent}
                   </DialogContent>
            <DialogActions>
             <Button onClick={this.props.onClose} color="primary">
               Ok
             </Button>
              
           </DialogActions>
          </Dialog>
        ) : "";
    }
}

export default ResourcesDialog;
